<template>
  <div class="container mb-sm-5 mb-3">
    <div class="dashboard">
      <div class="row">
        <div class="col-lg-3 col-md-4 mb-3">
          <div class="sidebar">
            <ul>
              <li>
                <a href="#" class="dashboards"> <i class="fas fa-home-alt me-2"></i>Dashboard</a>
              </li>
              <li>
                <a :href="props.myProfileRoute"><i class="fas fa-user me-2"></i>User Profile</a>
              </li>
              <li>
                <a :href="props.addPet"><i class="fas fa-paw me-2"></i>My Pets</a>
              </li>
              <li>
                <a :href="props.myBookings"><i class="fas fa-calendar-check me-2"></i>My Bookings</a>
              </li>
              <li>
                <a :href="props.logoutRoute"><i class="fas fa-sign-out me-2"></i>Logout</a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <!-- <div class="main-content">
        <h1>Welcome to Your Dashboard, {{ username }}</h1>
        <div class="stats">
          <div class="stat-card">
            <h2>Total Orders</h2>
            <p>{{ totalOrders }}</p>
          </div>
          <div class="stat-card">
            <h2>Balance</h2>
            <p>${{ balance }}</p>
          </div>
        </div>
        <h2>Recent Orders</h2>
        <ul class="order-list">
          <li v-for="order in recentOrders" :key="order.id">
            <span>{{ order.date }}</span>
            <span>{{ order.product }}</span>
            <span>${{ order.amount }}</span>
          </li>
        </ul>
      </div> -->
    </div>
  </div>
</template>

  <script setup>
import { ref, onMounted } from 'vue'

const props = defineProps({
  logoutRoute: String,
  addPet: String,
  myBookings: String,
  myProfileRoute: String
})
const username = ref('John Doe')
const totalOrders = ref(10)
const balance = ref(500)
const recentOrders = ref([
  { id: 1, date: '2024-03-06', product: 'Product A', amount: 50 },
  { id: 2, date: '2024-03-05', product: 'Product B', amount: 100 },
  { id: 3, date: '2024-03-04', product: 'Product C', amount: 150 },
  { id: 4, date: '2024-03-03', product: 'Product D', amount: 200 }
])
</script>

  <style scoped>
.sidebar {
  max-width: 100%;
  background-color: #ffffff;
  padding: 20px;
  height: 398px;
  margin-top: 40px;
  top: 35px;
  position: static;
  border-radius: 10px;
  box-shadow: none !important;
}

.sidebar h2 {
  margin-bottom: 20px;
}

.sidebar ul {
  list-style: none;
  padding: 0;
}

.sidebar ul li {
  margin-bottom: 20px;
}

.sidebar ul li a {
  text-decoration: none;
  color: #000;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
}
.sidebar ul li a:hover {
  color: #bf360c;
}

.main-content {
  flex: 1;
  padding: 20px;
  margin-left: 0px !important;
  border-radius: 10px;
  margin-top: 40px;
  background-color: white;
}

.stats {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}

.stat-card {
  flex: 1;
  padding: 10px;
  background-color: #f0f0f0;
  border-radius: 5px;
  text-align: center;
}

.order-list {
  list-style: none;
  padding: 0;
}

.order-list li {
  margin-bottom: 5px;
  border: 1px solid #ddd;
  padding: 5px;
  display: flex;
  justify-content: space-between;
}
.web-bg {
  background-color: #fbfbfb;
}
.dashboards {
  color: #bf360c !important;
}
</style>


